import { faBasketShopping } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { T } from "@repo/transifex";

type AddToOrderButtonProps = {
  price?: string;
  unitSystemLabel?: string;
} & JSX.IntrinsicElements["button"];

export const AddToOrderButton = ({
  price,
  unitSystemLabel,
  ...props
}: AddToOrderButtonProps) => {
  return (
    <button
      type="button"
      className="flex h-24 w-full items-center justify-between rounded-xl bg-kiosk-product-button-primary-background px-8 text-kiosk-product-button-primary-text disabled:cursor-not-allowed disabled:opacity-50"
      {...props}
    >
      <div className="flex items-center gap-2 text-3xl font-bold">
        <FontAwesomeIcon icon={faBasketShopping} />
        <T _str="Add" />
      </div>

      {unitSystemLabel ? (
        <div className="flex flex-col items-end text-3xl">
          {price ? <p className="font-bold">{price}</p> : null}
          <p>{unitSystemLabel}</p>
        </div>
      ) : null}

      {price && !unitSystemLabel ? (
        <p className="text-5xl font-bold">{price}</p>
      ) : null}
    </button>
  );
};
